import { useState, useEffect } from 'react';
import { ArrowLeft } from 'lucide-react';
import { useNavigate, useParams } from 'react-router-dom';
import { getUsernameHistory, type UsernameChange } from '../config/firebase';
import { Timestamp } from 'firebase/firestore';

export function UsernameHistory() {
  const navigate = useNavigate();
  const { userId } = useParams();
  const [history, setHistory] = useState<UsernameChange[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadHistory = async () => {
      if (!userId) return;
      const data = await getUsernameHistory(userId);
      setHistory(data);
      setLoading(false);
    };

    loadHistory();
  }, [userId]);

  return (
    <div className="container mx-auto px-4 py-8 max-w-2xl">
      <div className="flex items-center justify-between mb-6">
        <button
          onClick={() => navigate(-1)}
          className="text-gray-400 hover:text-white transition-colors"
        >
          <ArrowLeft className="w-6 h-6" />
        </button>
        <h1 className="text-xl font-bold text-white">Historique des noms</h1>
        <div className="w-6" /> {/* Spacer pour centrer le titre */}
      </div>
      
      {loading ? (
        <p className="text-gray-400 text-center">Chargement...</p>
      ) : history.length > 0 ? (
        <div className="space-y-4">
          {history.map((change, index) => (
            <div key={index} className="bg-white/5 p-4 rounded-xl">
              <p className="text-white font-bold">{change.username}</p>
              <p className="text-gray-400 text-sm">
                Changé le {change.changedAt instanceof Timestamp 
                  ? change.changedAt.toDate().toLocaleDateString('fr-FR')
                  : new Date(change.changedAt).toLocaleDateString('fr-FR')}
              </p>
            </div>
          ))}
        </div>
      ) : (
        <p className="text-gray-400 text-center">Aucun changement de nom</p>
      )}
    </div>
  );
} 